import { HttpService } from "@/core/services/http.service";
export class BtnService {
  static useDeleteApi() {
    const api = (bizId, data: { bizType: string; recycleDesc: string }) =>
      HttpService.axios({
        method: "PUT",
        url: `/common_api/moveToRecycle/${bizId}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }
  
  static useDeleteCompletelyApi() {
    const api = (data: { bizIds: string[]; bizType: string }) =>
      HttpService.axios({
        method: "POST",
        url: `/common_api/delete/bizIds/bizType`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useRecycleApi() {
    const api = (bizId: string,bizType: string ) =>
      HttpService.axios({
        method: "PUT",
        url: `/common_api/recoverFromRecycle/${bizId}/${bizType}`,
      });
    return HttpService.useRequest<void>(api);
  }
  // 作废
  static useVoidApi() {
    const api = (data:any) =>
      HttpService.axios({
        method: "POST",
        url: `/common_api/cancel`,
        data:data,
      });
    return HttpService.useRequest<void>(api);
  }
}
